const hamburger = () => {
  const toggler = document.querySelector('.js-menu');
  const menu = document.querySelector('.js-menu-nav');

  if (!toggler) return;

  toggler.addEventListener('click', () => {
    if (Array.from(menu.classList).indexOf('show-menu') !== -1) {
      menu.classList.remove('show-menu');
    } else {
      menu.classList.add('show-menu');
    }
  });
}

export default hamburger;



// WEBPACK FOOTER //
// ./scripts/modules/hamburger.js